class ShopifyImageComparison {
  constructor() {
    // IL TUO TOKEN
    this.storefrontAccessToken = "66540010db710c5f53c3a188cfc61d3c";
    this.graphqlEndpoint = "/api/2024-01/graphql.json";

    this.currentVariantId = null;
    this.currentProductId = null;
    this.variantDataMap = new Map();
    this.productDataMap = new Map();
    this.isFetching = false;

    this.init();
  }

  init() {
    console.log("ShopifyImageComparison initialized");

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => this.start());
    } else {
      this.start();
    }
  }

  start() {
    // Trova il wrapper principale e i container delle immagini
    this.wrapper = document.querySelector(".image-comparison--wrapper");
    this.beforeContainer = document.querySelector(
      ".image-comparison--before picture"
    );
    this.afterContainer = document.querySelector(
      ".image-comparison--after picture"
    );

    if (!this.wrapper) {
      console.error("Wrapper image-comparison--wrapper non trovato!");
      return;
    }

    if (!this.beforeContainer || !this.afterContainer) {
      console.error("Contenitori immagini non trovati!");
      return;
    }

    console.log("Tutti gli elementi trovati");

    this.bindEvents();
    this.detectCurrentVariant();
  }

  detectProductId() {
    console.log("=== RICERCA PRODUCT ID CORRETTA ===");

    // METODO 1: Cerca nei JSON della pagina (il metodo più affidabile)
    const scriptElements = document.querySelectorAll(
      'script[type="application/json"]'
    );
    for (const script of scriptElements) {
      try {
        const data = JSON.parse(script.textContent);
        console.log("JSON trovato:", data);

        // Cerca in diverse strutture comuni di Shopify
        if (data.product && data.product.id) {
          // Estrai solo l'ID numerico dal GID
          const productId = this.extractNumericId(data.product.id);
          if (productId) {
            this.currentProductId = productId;
            console.log(
              "✅ Product ID trovato dal JSON product.id:",
              this.currentProductId
            );
            return;
          }
        }

        // Cerca in altre strutture
        if (data.id && data.id.toString().includes("gid://shopify/Product/")) {
          const productId = this.extractNumericId(data.id);
          if (productId) {
            this.currentProductId = productId;
            console.log(
              "✅ Product ID trovato dal JSON data.id:",
              this.currentProductId
            );
            return;
          }
        }

        // Cerca in product.variants[0].product_id
        if (
          data.product &&
          data.product.variants &&
          data.product.variants.length > 0
        ) {
          const productId = data.product.variants[0].product_id;
          if (productId) {
            this.currentProductId = productId.toString();
            console.log(
              "✅ Product ID trovato da product.variants[0].product_id:",
              this.currentProductId
            );
            return;
          }
        }
      } catch (e) {
        continue;
      }
    }

    // METODO 2: Cerca in meta tags
    const metaProductId = document.querySelector(
      'meta[name="shopify-digital-river-product-id"]'
    );
    if (metaProductId) {
      const productId = metaProductId.getAttribute("content");
      if (productId) {
        this.currentProductId = productId;
        console.log(
          "✅ Product ID trovato dal meta tag:",
          this.currentProductId
        );
        return;
      }
    }

    // METODO 3: Cerca in data attributes che contengono Product ID numerico
    const productIdElements = document.querySelectorAll("[data-product-id]");
    for (const element of productIdElements) {
      const productId = element.getAttribute("data-product-id");
      // Verifica che sia un ID numerico (non un ID di template)
      if (productId && /^\d+$/.test(productId)) {
        this.currentProductId = productId;
        console.log(
          "✅ Product ID trovato da data-product-id numerico:",
          this.currentProductId
        );
        return;
      }
    }

    // METODO 4: Cerca nell'URL e usa GraphQL per ottenere l'ID dall'handle
    const urlMatch = window.location.pathname.match(/\/products\/([^\/]+)/);
    if (urlMatch) {
      const productHandle = urlMatch[1];
      console.log("Product handle trovato dall URL:", productHandle);
      // Non possiamo fare GraphQL qui perché è async, ma lo useremo come fallback dopo
    }

    console.log(
      "❌ Product ID non trovato con metodi diretti, userò GraphQL dalla variante"
    );
  }

  extractNumericId(gid) {
    if (!gid) return null;

    // Se è già un ID numerico
    if (typeof gid === "number" || /^\d+$/.test(gid)) {
      return gid.toString();
    }

    // Se è un GID Shopify
    if (gid.toString().includes("gid://shopify/Product/")) {
      const matches = gid.toString().match(/gid:\/\/shopify\/Product\/(\d+)/);
      return matches ? matches[1] : null;
    }

    return null;
  }

  async getProductIdFromVariant(variantId) {
    try {
      const query = `
        query GetProductIdFromVariant($id: ID!) {
          node(id: $id) {
            ... on ProductVariant {
              id
              product {
                id
              }
            }
          }
        }
      `;

      const variables = {
        id: `gid://shopify/ProductVariant/${variantId}`,
      };

      console.log("Fetching Product ID dalla variante via GraphQL...");

      const response = await fetch(this.graphqlEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": this.storefrontAccessToken,
        },
        body: JSON.stringify({
          query,
          variables,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (result.errors) {
        console.error("GraphQL errors:", result.errors);
        return null;
      }

      const productGid = result.data?.node?.product?.id;
      if (productGid) {
        // Estrai solo l'ID numerico dal GID
        const numericId = this.extractNumericId(productGid);
        console.log(
          "✅ Product ID ottenuto dalla variante via GraphQL:",
          numericId
        );
        return numericId;
      }

      return null;
    } catch (error) {
      console.error("Errore nel fetch Product ID:", error);
      return null;
    }
  }

  async getProductIdFromHandle(productHandle) {
    try {
      const query = `
        query GetProductIdFromHandle($handle: String!) {
          productByHandle(handle: $handle) {
            id
          }
        }
      `;

      const variables = {
        handle: productHandle,
      };

      console.log(
        "Fetching Product ID dall handle via GraphQL...",
        productHandle
      );

      const response = await fetch(this.graphqlEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": this.storefrontAccessToken,
        },
        body: JSON.stringify({
          query,
          variables,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (result.errors) {
        console.error("GraphQL errors:", result.errors);
        return null;
      }

      const productGid = result.data?.productByHandle?.id;
      if (productGid) {
        const numericId = this.extractNumericId(productGid);
        console.log(
          "✅ Product ID ottenuto dall handle via GraphQL:",
          numericId
        );
        return numericId;
      }

      return null;
    } catch (error) {
      console.error("Errore nel fetch Product ID da handle:", error);
      return null;
    }
  }

  bindEvents() {
    // Ascolta i click sulle label degli swatch
    document.addEventListener("click", (event) => {
      const label = event.target.closest(".arca-swatch-label");
      if (label) {
        console.log("Click su swatch label:", label);
        setTimeout(() => {
          this.detectCurrentVariant();
        }, 100);
      }
    });

    // Ascolta i change sui radio button
    document.addEventListener("change", (event) => {
      if (event.target.classList.contains("arca-swatch-input")) {
        console.log("Change su radio swatch:", event.target.value);
        setTimeout(() => {
          this.detectCurrentVariant();
        }, 100);
      }
    });
  }

  detectCurrentVariant() {
    console.log("Rilevamento variante corrente...");

    // Cerca l'input hidden con name="id"
    let variantInput = document.querySelector('input[name="id"]');

    if (variantInput && variantInput.value) {
      console.log(
        'Variante trovata tramite input[name="id"]:',
        variantInput.value
      );
      this.handleVariantChange(variantInput.value);
      return;
    }

    console.log("Nessuna variante rilevata");
  }

  async handleVariantChange(variantId) {
    if (!variantId || variantId === this.currentVariantId || this.isFetching)
      return;

    console.log("Gestione cambio variante:", variantId);
    this.currentVariantId = variantId;

    // Se non abbiamo il Product ID, proviamo a ottenerlo ora
    if (!this.currentProductId) {
      console.log("Product ID non trovato, provo a ottenerlo...");
      await this.initializeProductId(variantId);
    }

    this.updateImageDisplay(variantId);
  }

  async initializeProductId(variantId) {
    // PRIMA: Prova a ottenere il Product ID dalla variante via GraphQL
    this.currentProductId = await this.getProductIdFromVariant(variantId);

    // SECONDA: Se non funziona, prova con l'handle dall'URL
    if (!this.currentProductId) {
      const urlMatch = window.location.pathname.match(/\/products\/([^\/]+)/);
      if (urlMatch) {
        const productHandle = urlMatch[1];
        this.currentProductId = await this.getProductIdFromHandle(
          productHandle
        );
      }
    }

    if (this.currentProductId) {
      console.log("✅ Product ID inizializzato:", this.currentProductId);
    } else {
      console.error("❌ Impossibile ottenere Product ID");
    }
  }

  updateImageDisplay(variantId) {
    const imageData = this.variantDataMap.get(variantId.toString());

    if (imageData) {
      console.log("Dati immagini trovati nella cache:", imageData);
      this.updateImages(imageData);
    } else {
      console.log(
        "Dati immagini non trovati in cache, fetching via GraphQL..."
      );
      this.fetchAllImagesWithGraphQL(variantId);
    }
  }

  async fetchAllImagesWithGraphQL(variantId) {
    if (this.isFetching) return;

    this.isFetching = true;

    try {
      console.log("=== INIZIO FETCH GRAPHQL ===");
      console.log("Variant ID:", variantId);
      console.log("Product ID:", this.currentProductId);

      // STEP 1: Fetch dati variante con namespace "variante"
      const variantData = await this.fetchVariantImages(variantId);
      console.log("Dati variante dopo fetch:", variantData);

      // STEP 2: Decidi il prossimo passo in base ai risultati della variante
      if (this.hasAnyImage(variantData)) {
        // 🎯 CASO 1: Variante HA immagini - uso quelle
        console.log("✅ Variante HA immagini, uso quelle");
        this.variantDataMap.set(variantId.toString(), variantData);
        this.showWrapper();
        this.updateImages(variantData);
      } else if (this.currentProductId) {
        // 🔄 CASO 2: Variante NON HA immagini - controllo prodotto
        console.log("🔄 Variante NON ha immagini, controllo prodotto...");
        const productData = await this.fetchProductImages(
          this.currentProductId
        );
        console.log("Dati prodotto dopo fetch:", productData);

        if (this.hasAnyImage(productData)) {
          // 🎯 CASO 2A: Prodotto HA immagini - uso quelle
          console.log("✅ Prodotto HA immagini, uso quelle");
          const finalData = this.combineImageData({}, productData);
          this.variantDataMap.set(variantId.toString(), finalData);
          this.showWrapper();
          this.updateImages(finalData);
        } else {
          // ❌ CASO 2B: Prodotto NON HA immagini - nascondi tutto
          console.log("❌ Prodotto NON ha immagini, nascondo wrapper");
          this.hideWrapper();
        }
      } else {
        // ❌ CASO 3: Variante senza immagini e senza Product ID
        console.log(
          "❌ Variante senza immagini e senza Product ID, nascondo wrapper"
        );
        this.hideWrapper();
      }
    } catch (error) {
      console.error("Errore durante il fetch:", error);
      this.hideWrapper();
    } finally {
      this.isFetching = false;
      console.log("=== FINE FETCH GRAPHQL ===");
    }
  }

  async fetchVariantImages(variantId) {
    const query = `
      query GetVariantImages($id: ID!) {
        node(id: $id) {
          ... on ProductVariant {
            id
            title
            fotoBeforeDesktop: metafield(namespace: "variante", key: "foto_before_desktop") {
              value
              type
            }
            fotoBeforeMobile: metafield(namespace: "variante", key: "foto_before_mobile") {
              value
              type
            }
            fotoAfterDesktop: metafield(namespace: "variante", key: "foto_after_desktop") {
              value
              type
            }
            fotoAfterMobile: metafield(namespace: "variante", key: "foto_after_mobile") {
              value
              type
            }
          }
        }
      }
    `;

    const variables = {
      id: `gid://shopify/ProductVariant/${variantId}`,
    };

    console.log('Fetching variant images con namespace "variante"...');

    const response = await fetch(this.graphqlEndpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": this.storefrontAccessToken,
      },
      body: JSON.stringify({
        query,
        variables,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();

    if (result.errors) {
      console.error("GraphQL errors per variant:", result.errors);
      return this.createEmptyImageData();
    }

    const variantNode = result.data?.node;
    console.log("Nodo variante completo:", variantNode);

    // Estrai i GID dai metafield della variante
    const gids = {
      beforeDesktop: this.extractGID(variantNode?.fotoBeforeDesktop?.value),
      beforeMobile: this.extractGID(variantNode?.fotoBeforeMobile?.value),
      afterDesktop: this.extractGID(variantNode?.fotoAfterDesktop?.value),
      afterMobile: this.extractGID(variantNode?.fotoAfterMobile?.value),
    };

    console.log("GID variante estratti:", gids);

    // Fetch URL dalle immagini
    const urls = await this.fetchImageUrlsFromGIDs(gids);
    console.log("URL variante:", urls);

    return urls;
  }

  async fetchProductImages(productId) {
    console.log("Fetch immagini prodotto per Product ID:", productId);
    if (!productId) {
      console.log("Nessun Product ID, salto fetch prodotto");
      return this.createEmptyImageData();
    }

    const query = `
      query GetProductImages($id: ID!) {
        node(id: $id) {
          ... on Product {
            id
            title
            fotoBeforeDesktop: metafield(namespace: "custom", key: "foto_before_desktop") {
              value
              type
            }
            fotoBeforeMobile: metafield(namespace: "custom", key: "foto_before_mobile") {
              value
              type
            }
            fotoAfterDesktop: metafield(namespace: "custom", key: "foto_after_desktop") {
              value
              type
            }
            fotoAfterMobile: metafield(namespace: "custom", key: "foto_after_mobile") {
              value
              type
            }
          }
        }
      }
    `;

    const variables = {
      id: `gid://shopify/Product/${productId}`,
    };

    console.log('Fetching product images con namespace "custom"...');

    const response = await fetch(this.graphqlEndpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": this.storefrontAccessToken,
      },
      body: JSON.stringify({
        query,
        variables,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();

    if (result.errors) {
      console.error("GraphQL errors per product:", result.errors);
      return this.createEmptyImageData();
    }

    const productNode = result.data?.node;
    console.log("Nodo prodotto completo:", productNode);

    // Estrai i GID dai metafield del prodotto
    const gids = {
      beforeDesktop: this.extractGID(productNode?.fotoBeforeDesktop?.value),
      beforeMobile: this.extractGID(productNode?.fotoBeforeMobile?.value),
      afterDesktop: this.extractGID(productNode?.fotoAfterDesktop?.value),
      afterMobile: this.extractGID(productNode?.fotoAfterMobile?.value),
    };

    console.log("GID prodotto estratti:", gids);

    // Fetch URL dalle immagini
    const urls = await this.fetchImageUrlsFromGIDs(gids);
    console.log("URL prodotto:", urls);

    return urls;
  }

  createEmptyImageData() {
    return {
      beforeDesktop: null,
      beforeMobile: null,
      afterDesktop: null,
      afterMobile: null,
    };
  }

  combineImageData(variantData, productData) {
    // Combina i dati con priorità variante → prodotto
    return {
      beforeDesktop: variantData.beforeDesktop || productData.beforeDesktop,
      beforeMobile: variantData.beforeMobile || productData.beforeMobile,
      afterDesktop: variantData.afterDesktop || productData.afterDesktop,
      afterMobile: variantData.afterMobile || productData.afterMobile,
    };
  }

  hasAnyImage(imageData) {
    // Controlla se c'è almeno un'immagine valida
    return !!(
      imageData.beforeDesktop ||
      imageData.beforeMobile ||
      imageData.afterDesktop ||
      imageData.afterMobile
    );
  }

  showWrapper() {
    if (this.wrapper) {
      this.wrapper.style.display = "block";
      console.log("✅ Wrapper mostrato");
    }
  }

  hideWrapper() {
    if (this.wrapper) {
      this.wrapper.style.display = "none";
      console.log("❌ Wrapper nascosto");
    }
  }

  extractGID(value) {
    if (!value) return null;

    if (value.startsWith("gid://")) {
      return value;
    }

    try {
      const data = JSON.parse(value);
      if (data.id && data.id.startsWith("gid://")) {
        return data.id;
      }
    } catch (e) {
      // Non è JSON
    }

    return null;
  }

  async fetchImageUrlsFromGIDs(imageGIDs) {
    const urls = this.createEmptyImageData();

    const gidsToFetch = [];
    const gidMap = {};

    Object.entries(imageGIDs).forEach(([key, gid]) => {
      if (gid) {
        gidsToFetch.push(gid);
        gidMap[gid] = key;
      }
    });

    if (gidsToFetch.length === 0) {
      return urls;
    }

    try {
      const query = `
        query GetImageUrls($ids: [ID!]!) {
          nodes(ids: $ids) {
            ... on MediaImage {
              id
              image {
                url
              }
            }
            ... on GenericFile {
              id
              url
            }
          }
        }
      `;

      const variables = {
        ids: gidsToFetch,
      };

      console.log("Fetching URLs from GIDs:", gidsToFetch);

      const response = await fetch(this.graphqlEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": this.storefrontAccessToken,
        },
        body: JSON.stringify({
          query,
          variables,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (result.errors) {
        console.error("GraphQL errors per URLs:", result.errors);
        return urls;
      }

      console.log("Risultato fetch URLs:", result.data?.nodes);

      result.data?.nodes?.forEach((node) => {
        if (node) {
          const fieldKey = gidMap[node.id];
          if (fieldKey) {
            if (node.image && node.image.url) {
              urls[fieldKey] = node.image.url;
            } else if (node.url) {
              urls[fieldKey] = node.url;
            }
          }
        }
      });
    } catch (error) {
      console.error("Errore nel fetch URL immagini:", error);
    }

    return urls;
  }

  updateImages(imageData) {
    console.log("Aggiornamento immagini con dati:", imageData);

    const finalImages = {
      beforeDesktop: imageData.beforeDesktop || imageData.beforeMobile,
      beforeMobile: imageData.beforeMobile,
      afterDesktop: imageData.afterDesktop || imageData.afterMobile,
      afterMobile: imageData.afterMobile,
    };

    console.log("Immagini finali dopo fallback:", finalImages);

    // Aggiorna le immagini
    this.updateBeforeImages(finalImages);
    this.updateAfterImages(finalImages);
  }

  updateBeforeImages(imageData) {
    const beforePicture = this.beforeContainer;
    beforePicture.innerHTML = "";

    const imageUrl = imageData.beforeDesktop || imageData.beforeMobile;

    if (!imageUrl) {
      console.log("Nessuna immagine BEFORE disponibile");
      return;
    }

    if (imageData.beforeMobile) {
      const mobileSource = document.createElement("source");
      mobileSource.media = "(max-width: 767px)";
      mobileSource.srcset = this.generateSrcSet(imageData.beforeMobile);
      mobileSource.sizes = "(max-width: 767px) calc(100vw - 32px), 1200px";
      beforePicture.appendChild(mobileSource);
    }

    const mainImage = document.createElement("img");
    mainImage.src = this.addWidthParam(imageUrl, 2100);
    mainImage.srcset = this.generateSrcSet(imageUrl);
    mainImage.alt = "Prima";
    mainImage.width = 2100;
    mainImage.height = 1100;
    mainImage.loading = "lazy";
    mainImage.sizes = "(max-width: 767px) calc(100vw - 32px), 1200px";
    mainImage.setAttribute("data-cmp-info", "10");

    beforePicture.appendChild(mainImage);

    console.log("✅ Immagine BEFORE aggiornata:", imageUrl);
  }

  updateAfterImages(imageData) {
    const afterPicture = this.afterContainer;
    afterPicture.innerHTML = "";

    const imageUrl = imageData.afterDesktop || imageData.afterMobile;

    if (!imageUrl) {
      console.log("Nessuna immagine AFTER disponibile");
      return;
    }

    if (imageData.afterMobile) {
      const mobileSource = document.createElement("source");
      mobileSource.media = "(max-width: 767px)";
      mobileSource.srcset = this.generateSrcSet(imageData.afterMobile);
      mobileSource.sizes = "(max-width: 767px) calc(100vw - 32px), 1200px";
      afterPicture.appendChild(mobileSource);
    }

    const mainImage = document.createElement("img");
    mainImage.src = this.addWidthParam(imageUrl, 2100);
    mainImage.srcset = this.generateSrcSet(imageUrl);
    mainImage.alt = "Dopo";
    mainImage.width = 2100;
    mainImage.height = 1100;
    mainImage.loading = "lazy";
    mainImage.sizes = "(max-width: 767px) calc(100vw - 32px), 1200px";
    mainImage.setAttribute("data-cmp-info", "10");

    afterPicture.appendChild(mainImage);

    console.log("✅ Immagine AFTER aggiornata:", imageUrl);
  }

  generateSrcSet(imageUrl) {
    const widths = [
      200, 300, 400, 500, 600, 700, 800, 900, 1000, 1200, 1400, 1600, 1800,
      2000,
    ];
    return widths
      .map((width) => {
        return `${this.addWidthParam(imageUrl, width)} ${width}w`;
      })
      .join(", ");
  }

  addWidthParam(imageUrl, width) {
    const baseUrl = imageUrl.split("?")[0];
    return `${baseUrl}?width=${width}`;
  }
}

// Inizializza l'app
document.addEventListener("DOMContentLoaded", () => {
  new ShopifyImageComparison();
});
